import React from "react";
import { Layout, SectionContent, SectionHead } from "@layouts/MainLayout";
import { useTranslation } from "react-i18next";
import { Typography } from "@mui/material";

const HelpCenterMain: React.FC = () => {
  const { t } = useTranslation();
  const content = t("help.content", { returnObjects: true }) as any[];

  return (
    <Layout>
      <SectionHead title={t("general.helpCenter")} />

      <SectionContent>
        {content.map((item, index) => (
          <div key={index} className="flex flex-col gap-4 pb-4">
            {item.title && (
              <Typography
                variant="h6"
                sx={{ color: "primary.main", fontWeight: "bold" }}
              >
                {item.title}
              </Typography>
            )}

            {item.description &&
              item.description.map((desc: string, descIndex: number) => (
                <p
                  key={`${index}_desc_${descIndex}`}
                  dangerouslySetInnerHTML={{ __html: desc }}
                />
              ))}

            {item.screenshot && <img src={item.screenshot} alt="screenshot" />}

            {item.numberedList && (
              <ol className="flex flex-col gap-3 px-5">
                {item.numberedList.map((step: any, stepIndex: number) => (
                  <li key={`${index}_step_${stepIndex}`}>
                    <strong>
                      {stepIndex + 1}. {step.step}
                    </strong>
                    <p dangerouslySetInnerHTML={{ __html: step.description }} />
                    {step.screenshot && (
                      <img
                        src={step.screenshot}
                        alt="screenshot"
                        className="w-4/6 px-8"
                      />
                    )}
                  </li>
                ))}
              </ol>
            )}
          </div>
        ))}
      </SectionContent>
    </Layout>
  );
};

export default HelpCenterMain;
